// @ts-nocheck
/* eslint-disable */
export const openJamIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M240-120h480v-60H510v-339l78 78 46-46-154-154-154 154 46 46 78-78v339H240v60Zm240-360ZM140-328q-24 0-42-18t-18-42v-392q0-24 18-42t42-18h680q24 0 42 18t18 42v392q0 24-18 42t-42 18H610v-60h210v-392H140v392h210v60H140Z"/></svg>`,
    name: 'open-jam' as const
};